import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import {
  Box,
  CarouselMobile,
  Center,
  Circle,
  InteractiveSpan,
  Padding,
  Stack,
  Text,
} from '../../components';
import { MeetTheTeamData } from './shared';

const SpanWrapper = styled.div<any>`
  width: 100%;
  text-align: ${({ alignment }: any) => alignment || 'left'};
`;

const MeetTheTeamComponent = (props) => {
  let { value } = props;
  let { image, name, position, description, url } = value || {
    title: '',
    description: '',
  };
  return (
    <Stack size={4}>
      <Center>
        <Circle size={9}>
          <Box ratio={1} backgroundImage={image} />
        </Circle>
      </Center>
      <Stack>
        <Text textType="primary1">{name}</Text>
        <Text textType="primary1">{position}</Text>
        <Text textType="primary2">{description}</Text>
        <SpanWrapper alignment="center">
          <InteractiveSpan
            textType="primary2"
            underlined
            onClick={() => {
              track(`Meet the Team`, {
                name: value?.name?.split(' ')[0],
              });
              window.open(url);
            }}
          >
            Meet {name?.split(' ')[0]}
          </InteractiveSpan>
        </SpanWrapper>
      </Stack>
    </Stack>
  );
};

export const MeetTheTeamMobile = () => {
  return (
    <Padding size={[6]}>
      <Stack size={5}>
        <Padding size={[5, 0]}>
          <Text textType="heading3">Meet the Team</Text>
        </Padding>
        <CarouselMobile buttoned duration={0}>
          {_.flow((MeetTheTeamData) =>
            _.map(MeetTheTeamData, (value, index) => {
              return <MeetTheTeamComponent value={value} key={index} />;
            })
          )(MeetTheTeamData)}
        </CarouselMobile>
      </Stack>
    </Padding>
  );
};
